module.exports = __webpack_public_path__ + "img/pocket-mobile_jp.f677daa.jpg";